import { z } from "zod";

import { zCmpOp } from "../../../../../types/ZCmpOp";

export const zExprTrue = z.object({
  type: z.literal("true"),
});

export const zExprBoolField = z.object({
  type: z.literal("boolField"),
  path: z.string(),
  inv: z.boolean().optional(),
});

export const zExprFieldValue = z.object({
  type: z.literal("fieldValue"),
  op: zCmpOp,
  path: z.string(),
  value: z.string().or(z.number()),
});

type ZExprBoolList = ZExprBool[];
export const zExprBoolList: z.ZodType<ZExprBoolList> = z.lazy(() =>
  zExprBool.array(),
);

export const zExprOr = z.object({
  type: z.literal("or"),
  ops: zExprBoolList,
});

export const zExprBool = z.discriminatedUnion("type", [
  zExprTrue,
  zExprBoolField,
  zExprFieldValue,
  zExprOr,
]);
export type ZExprBool = z.infer<typeof zExprBool>;
